var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isProductionCode)?_c('div',{staticClass:"text-center"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.config.statCounterTrackingCode)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }